module.exports = __webpack_public_path__ + "img/longta.c30790e5.jpg";